// The PUBLIC half of the rental signing keypair (RSA-2048, RS256).
//
// This is the VERIFICATION half only. It is safe to commit and ship to the
// client — a public key reveals nothing. The matching PRIVATE key lives in
// Secret Manager under the secret `rental-signing-private-key` and never leaves
// the server (see functions/lib/rentalSigning.js).
//
// HOW TO POPULATE THIS:
//   The keypair is created by the one-off generator, which prints the public key
//   in SPKI PEM form:
//     cd functions
//     node scripts/generateRentalSigningKeypair.js            # dry run, prints nothing new
//     EXECUTE_REFUSAL="I have generated the platform rental signing keypair" \
//       node scripts/generateRentalSigningKeypair.js          # creates the keypair
//   The generator is non-destructive: if the keypair already exists it simply
//   reuses it and re-prints the same public key. Paste the printed
//   "-----BEGIN PUBLIC KEY-----...-----END PUBLIC KEY-----" block between the
//   backticks below, then commit.
//
// If this is ever blanked out, verifyRentalToken() treats every token as
// invalid (an empty key cannot verify anything), which fails closed — the safe
// direction.
//
// Populated on 2026-06-12 from the generator's execute run. Its matching private
// key lives in Secret Manager (rental-signing-private-key) and was never printed.
export const RENTAL_SIGNING_PUBLIC_KEY_PEM = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEApa/H/3+/9MVUAPUDZE5C
39xgcBYpM1yDxGwq4FY/6ZbfQc95Hp2X6+6VMABuGB4FRwkph7b2QxiLErriYLDS
Pv+FFLg/yORDuDt+xQIGKvFZtZy7/Go0dAP5z1435M76RC2Jbk3NkkQRRuZLmusk
GUq9xuTnB5pCfk/8E5tb+4nEmnbev6yMV0gXx1rRbCzyL4rTkPvxBaRn8RfWa1ZB
6p9itqPN6s0b2TUoQweka0YZs9+fGquvUICPTWWh2hVaTx8G7doV+AyWZTz68uHS
KyvwSAL9kE/QVo39CLnIaTEnA97oVRLUEaD+hQyf/dUTP7rgJ/fQsVqZBDRhFwdc
PQIDAQAB
-----END PUBLIC KEY-----`;
